import { BorderWithRadius, BoxShadowWithRadiusAndSpace } from 'accessibility/focusStyles'
import classnames from 'classnames'
import BackArrow from 'components/lib/icons/BackArrow'
import Time from 'components/lib/icons/Time'
import NakedButton from 'components/lib/NakedButton'
import PresenceAvatar from 'components/PresenceAvatar'
import { useActiveSenderId } from 'hooks/useActiveSenderId'
import useConversationHistoryToggle from 'hooks/useConversationHistoryToggle'
import useIsMobile from 'hooks/useIsMobile'
import useKeyboardNavigation from 'hooks/useKeyboardNavigation'
import { useRecipientResolution } from 'hooks/useRecipientResolution'
import useThemeColors from 'hooks/useThemeColors'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import './style.css'

const ConversationHeader = () => {
  const historyRef = useRef<HTMLButtonElement>()
  const isHistoryKeyboardFocused = useKeyboardNavigation(historyRef)

  const { t } = useTranslation()
  const activeSenderId = useActiveSenderId()

  const { recipient } = useRecipientResolution(activeSenderId)
  const conversations = useSelector(state => (
    state.conversations.conversations
  ))

  const { backgroundStyles, conversationHeaderTextStyles, widgetSecondaryColor } = useThemeColors()

  const isMobile = useIsMobile()

  const {
    conversationHistoryEnabled,
    conversationHistoryOpen,
    onToggleConversationHistory
  } = useConversationHistoryToggle()

  const showConversationHistoryButton = conversationHistoryEnabled && !conversationHistoryOpen && Object.keys(conversations).length > 1

  const backButtonRef = useRef<HTMLButtonElement>()
  const isBackButtonKeyboardFocused = useKeyboardNavigation(backButtonRef)

  const handleOnOpenConversationHistory = () => {
    historyRef?.current?.blur()
    onToggleConversationHistory(!conversationHistoryOpen)
  }

  const handleOnCloseConversationHistory = () => {
    backButtonRef?.current?.blur()
    onToggleConversationHistory(!conversationHistoryOpen)
  }

  return (
    <div className="drift-widget-active-conversation-header">
      <PresenceAvatar size="SMALL" id={recipient.id} />
      <span
        aria-hidden={conversationHistoryOpen}
        className="drift-widget-recipient-name"
        style={conversationHeaderTextStyles}
      >
        {recipient.name}
      </span>

      <div
        className={classnames("drift-widget-conversation-history-header", {
          "drift-widget-conversation-history-header--open": conversationHistoryOpen
        })}
        style={backgroundStyles}
        aria-hidden={!conversationHistoryOpen}
      >
        <style>
          {`
            .drift-widget-history-back-button.keyboard-focused svg {
              ${BoxShadowWithRadiusAndSpace(backgroundStyles.background.toString().replace('#', ''), widgetSecondaryColor.replace('#', ''))}
            }
          `}
        </style>
        <NakedButton
          ref={backButtonRef}
          className={classnames("drift-widget-history-back-button", {
            'keyboard-focused': isBackButtonKeyboardFocused
          })}
          onClick={handleOnCloseConversationHistory}
          aria-label="Back to conversation"
          disabled={!conversationHistoryOpen}
        >
          <BackArrow color={widgetSecondaryColor} width={20} height={20} />
        </NakedButton>
        <span
          className="drift-widget-conversation-history--header-title"
          style={conversationHeaderTextStyles}
        >
          {t('history.headerTitle')}
        </span>
      </div>

      {showConversationHistoryButton &&
        <>
          <style>
            {`
              .drift-widget-history.keyboard-focused {
                ${BorderWithRadius(widgetSecondaryColor.replace('#', ''))}
              }
            `}
          </style>
          <NakedButton
            className={classnames("drift-widget-history", {
              "drift-widget-history--mobile": isMobile,
              "drift-widget-history--open": conversationHistoryOpen,
              "keyboard-focused": isHistoryKeyboardFocused
            })}
            aria-label="Open conversation history"
            disabled={conversationHistoryOpen}
            onClick={handleOnOpenConversationHistory}
            ref={historyRef}
          >
            <Time
              fill={widgetSecondaryColor}
              height={20}
              width={20}
            />
          </NakedButton>
        </>
      }
    </div>
  )
}


export default ConversationHeader
